module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-bnr-sp-28e85b6025ece9f654974c442511474d.png";